module.exports = __webpack_public_path__ + "static/media/poster1.e7b152e1.jpg";